import * as Sentry from "@sentry/react";
import { ERROR_SESSION_EXPIRED } from "constants/messages";
import { getAuth, signOut } from "firebase/auth";
import { useSnackbar } from "notistack";
import { isTokenExpired } from "utils/auth";

export default function AuthCheck() {
  const { enqueueSnackbar } = useSnackbar();
  const auth = getAuth();
  const fb_user = auth.currentUser;
  if (fb_user) {
    fb_user
      .getIdToken(/* forceRefresh */ false)
      .then(function (idToken) {
        if (isTokenExpired(idToken)) {
          enqueueSnackbar(ERROR_SESSION_EXPIRED, { variant: "error" });
          setTimeout(() => {
            signOut(auth);
          }, 1000);
        }
      })
      .catch(function (error) {
        Sentry.captureException(error);
      });
  }

  return null;
}
